import { CheckCircle2, GitBranch, RefreshCw } from "lucide-react";
import { useStoryPreferences } from "../i18n";

type StatusBarProps = { head: string; saved: boolean; invalidationCount?: number; connected?: boolean };

export function StatusBar({ head, saved, invalidationCount = 0, connected = false }: StatusBarProps) {
  const { t } = useStoryPreferences();
  return (
    <footer className="status-bar">
      <span><CheckCircle2 size={18} />{saved ? t("saved") : t("saving")}</span>
      <span><GitBranch size={18} />HEAD {head}</span>
      <span><RefreshCw size={18} />{invalidationCount > 0 ? `${invalidationCount} ${t("conflictsCount")}` : connected ? t("connected") : "Projection sync"} <i className={`sync-dot${invalidationCount > 0 ? " warning" : ""}`} /></span>
    </footer>
  );
}
